import * as actionTypes from './actionTypes';
import reduce from '../reduce';

const initialState = {
    taskCategories: [],
    taskCategoryId: null,
    tasks: [],
    taskCategorySelected: false,
    error: null,
    task: null,
    taskSelected: false,
    taskAccepted: false,
    taskAcceptedInfo: null,
    taskError: null,
    taskCanResume: false,
    taskResumeInfo: null,
    waiting: false,
    toCheckTaskBacklog: false,
}

const taskCategoriesReceived=(state, action)=>{
    return {
        ...state,
        taskCategories: action.taskCategories
    }
}

const commonError=(state, action)=> {
    return {
        ...state,
        error: action.error
    }
}

const selectedTaskCategory=(state,action)=>{
    return {
        ...state,
        taskCategoryId: action.taskCategoryId,
        tasks: action.tasks,
        taskCategorySelected: true
    }
}

const tasksListUIAcknowledge=(state,action)=>{
    return {
        ...state,
        taskCategorySelected: false
    }
}

const refreshTasks=(state, action)=>{
    return {
        ...state,
        tasks: action.tasks,
        taskCategoryId: action.taskCategoryId
    }
}

function taskSelect(state, action){
    return {
        ...state,
        task: action.task,
        taskSelected: true,
        toCheckTaskBacklog: true,
        taskAccepted: false
    }
}

function taskCancel(state){
    return {
        ...state,
        task: null,
        taskSelected: false,
        taskError: null
    }
}

function taskAccept(state,action){
    return {
        ...state,
        taskAccepted: true,
        taskAcceptedInfo: action.taskAcceptedInfo,
        waiting: false,
        toCheckTaskBacklog: false
    }
}

function taskCompleted(state){
    return {
        ...state,
        taskAccepted: false,
        taskAcceptedInfo: null,
        task: null,
        taskSelected: false
    }
}

function taskAcceptError(state,action){
    return {
        ...state,
        taskError: action.error,
        waiting: false
    }
}

function taskCanResume(state,action){
    let taskCanResume = true 
    if (!action.taskAcceptedInfo){
        taskCanResume = false
    }
    return {
        ...state,
        taskCanResume: taskCanResume,
        taskResumeInfo: action.taskAcceptedInfo,
        waiting: false,
        toCheckTaskBacklog: false
    }
}

function taskAcceptResume(state,action){
    return {
        ...state,
        taskCanResume: false,
        taskResumeInfo: null,
        taskError: null,
        taskAccepted: true,
        taskAcceptedInfo: action.taskAcceptedInfo
    }
}

const taskSelected=(state)=>{
    return {
        ...state,
        taskSelected: false,
        taskError: null,
    }
}

const receivedWaitingStatus=(state,action)=>{
    return {
        ...state,
        waiting: action.status
    }
}

export default reduce(initialState,{
    [actionTypes.TASK_SELECT]: taskSelect,
    [actionTypes.TASK_CANCEL]: taskCancel,
    [actionTypes.TASK_ACCEPT]: taskAccept,
    [actionTypes.TASK_COMPLETED]: taskCompleted,
    [actionTypes.TASK_ACCEPT_ERROR]: taskAcceptError,
    [actionTypes.TASK_CAN_RESUME]: taskCanResume,
    [actionTypes.TASK_ACCEPT_RESUME]: taskAcceptResume,
    [actionTypes.GET_TASK_CATEGORIES]: taskCategoriesReceived,
    [actionTypes.TASK_REDUCER_COMMON_ERROR]: commonError,
    [actionTypes.SELECT_TASK_CATEGORY]: selectedTaskCategory,
    [actionTypes.TASKS_LIST_UI_ACK]: tasksListUIAcknowledge,
    [actionTypes.REFRESH_TASKS_LIST]: refreshTasks,
    [actionTypes.TASK_SELECTED]: taskSelected,
    [actionTypes.SET_WAITING]: receivedWaitingStatus,
});


// WEBPACK FOOTER //
// ./src/redux/tasks/taskReducer.js